var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 12.1429L16.4875 8.5L10 4.85714V12.1429ZM24.45 2.635C24.6125 3.20571 24.725 3.97071 24.8 4.94214C24.8875 5.91357 24.925 6.75143 24.925 7.48L25 8.5C25 11.1593 24.8 13.1143 24.45 14.365C24.1375 15.4579 23.4125 16.1621 22.2875 16.4657C21.7 16.6236 20.625 16.7329 18.975 16.8057C17.35 16.8907 15.8625 16.9271 14.4875 16.9271L12.5 17C7.2625 17 4 16.8057 2.7125 16.4657C1.5875 16.1621 0.8625 15.4579 0.55 14.365C0.3875 13.7943 0.275 13.0293 0.2 12.0579C0.1125 11.0864 0.0749999 10.2486 0.0749999 9.52L0 8.5C0 5.84071 0.2 3.88571 0.55 2.635C0.8625 1.54214 1.5875 0.837857 2.7125 0.534286C3.3 0.376429 4.375 0.267143 6.025 0.194286C7.65 0.109286 9.1375 0.0728571 10.5125 0.0728571L12.5 0C17.7375 0 21 0.194286 22.2875 0.534286C23.4125 0.837857 24.1375 1.54214 24.45 2.635Z",
    fill: "#B3CFEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.b7adcf395990fed45093add8993dade1.svg";
export { ForwardRef as ReactComponent };